import * as R from 'ramda'
import { createSelector } from 'reselect'
import { getOperationCode, getCurrentProductKey } from 'store/selectors'
import {
  GetFilteredViewedProducts,
  GetHasCrossSaleOnLastViewedProducts,
  GetIsViewedProductsFetched,
  GetViewedProducts,
  WithDifferentOpeCode
} from './lastViewedProducts.types'

const withDifferentOpeCode: WithDifferentOpeCode = operationCode => (
  R.complement(R.propEq('operationCode', operationCode))
)

export const getViewedProducts: GetViewedProducts = R.path(['lastViewedProducts', 'products'])

export const getIsViewedProductsFetched: GetIsViewedProductsFetched = (
  R.path(['lastViewedProducts', 'isFetched'])
)

export const getFilteredViewedProducts: GetFilteredViewedProducts = createSelector(
  getViewedProducts,
  getCurrentProductKey,
  (viewedProducts, productKey: string) => {
    return R.ifElse(
      R.isNil,
      R.always(viewedProducts),
      R.always(R.filter(({ key }) => (key !== productKey))(viewedProducts))
    )(productKey)
  }
)

export const getHasCrossSaleOnLastViewedProducts: GetHasCrossSaleOnLastViewedProducts = createSelector(
  getViewedProducts,
  getOperationCode,
  (viewedProducts, operationCode: string) => R.pipe(
    R.find(withDifferentOpeCode(operationCode)),
    Boolean
  )(viewedProducts)
)
